import React, { useState } from "react";
import { motion } from "motion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { AiFillFileText, AiFillSafetyCertificate } from "react-icons/ai";
import { FaUser } from "react-icons/fa";
import { Sidebar, SidebarBody, SidebarLink } from "../../../utils/ui/sidebar";
import { cn } from "../../../lib/utils";
import Logout_Modal from "../../common-components/common-modals/logout_modal/Logout_Modal";

const iconClass = "h-6 w-6 shrink-0 text-neutral-900";

const imgIcon = (src) => (
  <img
    src={src}
    alt=""
    className="h-6 w-6 shrink-0 object-contain"
    style={{ width: 22, height: 22, minWidth: 22, objectFit: "contain" }}
  />
);

const tabs = [
  {
    tab_label: "Personal Details",
    icon: imgIcon("/assets/images/my_account/img1.png"),
  },
  {
    tab_label: "Order History",
    icon: imgIcon("/assets/images/my_account/img2.png"),
    subTabs: [
      {
        inner_tab: "In-Transit",
        icon: imgIcon("/assets/images/my_account/img3.png"),
      },
      {
        inner_tab: "Delivered",
        icon: imgIcon("/assets/images/my_account/img4.png"),
      },
      // {
      //   inner_tab: "Returned",
      //   icon: imgIcon("/assets/images/my_account/img5.png"),
      // },
      // {
      //   inner_tab: "Canceled",
      //   icon: imgIcon("/assets/images/my_account/img6.png"),
      // },
    ],
  },
  {
    tab_label: "Prescriptions",
    icon: imgIcon("/assets/images/my_account/img7.png"),
  },
  // {
  //   tab_label: "Appointments",
  //   icon: imgIcon("/assets/images/my_account/img8.png"),
  // },
  {
    tab_label: "Rewards",
    icon: imgIcon("/assets/images/my_account/img9.png"),
  },
  {
    tab_label: "Terms & Conditions",
    icon: <AiFillFileText className={iconClass} />,
  },
  {
    tab_label: "Privacy Policy",
    icon: <AiFillSafetyCertificate className={iconClass} />,
  },
];

const logoutIcon = imgIcon("/assets/images/my_account/img11.png");

const Logo = () => (
  <a
    href="#"
    onClick={(e) => e.preventDefault()}
    className="relative z-20 flex items-center space-x-2 px-3 py-1 text-sm text-black"
  >
    <FaUser className="h-5 w-5 shrink-0 text-neutral-900" />
    <motion.span
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="whitespace-pre text-lg font-semibold text-black"
    >
      My Account
    </motion.span>
  </a>
);

const LogoIcon = () => (
  <a
    href="#"
    onClick={(e) => e.preventDefault()}
    className="relative z-20 flex items-center justify-center py-1"
  >
    <FaUser className="h-5 w-5 shrink-0 text-neutral-900" />
  </a>
);

const Left_Tabs = (props) => {
  const [open, setOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [activeKey, setActiveKey] = useState("Personal Details");
  const [ordersExpanded, setOrdersExpanded] = useState(false);

  const closeOnMobile = () => {
    if (typeof window !== "undefined" && window.innerWidth < 768) {
      setOpen(false);
    }
  };

  const selectTab = (label) => {
    setActiveKey(label);
    props?.setSelectedTab(label);
    closeOnMobile();
  };

  const handleOrderHistory = () => {
    const orders = tabs.find((t) => t.tab_label === "Order History");
    const isOrderSub = orders.subTabs.some((s) => s.inner_tab === activeKey);

    // opening for the first time -> default to the first sub tab
    if (!ordersExpanded && !isOrderSub) {
      const first = orders.subTabs[0].inner_tab;
      setActiveKey(first);
      props?.setSelectedTab(first);
    }
    setOrdersExpanded((prev) => !prev);
  };

  // collapsed: centred icon tile, expanded: full-width row; active = white pill
  const linkClass = (isActive) =>
    cn(
      "rounded-lg py-2.5 transition-colors hover:bg-white/70",
      open ? "px-3" : "px-0 justify-center",
      isActive && "bg-white font-medium shadow-sm"
    );

  return (
    <section className="Left_Tabs h-full">
      <div className="h-full">
        <Sidebar open={open} setOpen={setOpen}>
          <SidebarBody
            className={cn(
              "justify-between gap-10 bg-[#e8eff2] dark:bg-[#e8eff2]",
              "md:px-2"
            )}
          >
            <div className="flex flex-1 flex-col overflow-x-hidden overflow-y-auto">
              {open ? <Logo /> : <LogoIcon />}

              <div className="mt-8 flex flex-col gap-2">
                {tabs.map((item) => {
                  const hasSubTabs = item.subTabs?.length > 0;

                  if (!hasSubTabs) {
                    return (
                      <SidebarLink
                        key={item.tab_label}
                        link={{
                          label: item.tab_label,
                          href: "#",
                          icon: item.icon,
                        }}
                        className={linkClass(activeKey === item.tab_label)}
                        onClick={(e) => {
                          e.preventDefault();
                          selectTab(item.tab_label);
                        }}
                      />
                    );
                  }

                  const isOrderSub = item.subTabs.some(
                    (s) => s.inner_tab === activeKey
                  );

                  return (
                    <React.Fragment key={item.tab_label}>
                      <SidebarLink
                        link={{
                          label: (
                            <span className="flex items-center gap-2">
                              {item.tab_label}
                              <FontAwesomeIcon
                                icon={ordersExpanded ? faSortUp : faSortDown}
                              />
                            </span>
                          ),
                          href: "#",
                          icon: item.icon,
                        }}
                        className={linkClass(isOrderSub)}
                        onClick={(e) => {
                          e.preventDefault();
                          handleOrderHistory();
                        }}
                      />

                      {open && ordersExpanded && (
                        <div className="ml-4 flex flex-col gap-1 border-l border-neutral-300 pl-2">
                          {item.subTabs.map((sub) => (
                            <SidebarLink
                              key={sub.inner_tab}
                              link={{
                                label: sub.inner_tab,
                                href: "#",
                                icon: sub.icon,
                              }}
                              className={linkClass(activeKey === sub.inner_tab)}
                              onClick={(e) => {
                                e.preventDefault();
                                selectTab(sub.inner_tab);
                              }}
                            />
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>

            <div>
              <SidebarLink
                link={{ label: "Logout", href: "#", icon: logoutIcon }}
                className={linkClass(false)}
                onClick={(e) => {
                  e.preventDefault();
                  setShowLogoutModal(true);
                }}
              />
            </div>
          </SidebarBody>
        </Sidebar>
      </div>

      <Logout_Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        questionText="Are you sure you want to logout?"
      />
    </section>
  );
};

export default Left_Tabs;